import React from "react"
import ReactDOM from "react-dom"
import PrintVersion from "core/gd/print-version/print-version"

import DocumentExportContainer from "../pdf-version/pdf-version"
import $ from 'jquery'

const debug = false
// const debug = "PrintVersionDocumentView"

export default class PrintVersionDocumentView extends PrintVersion {

    constructor(document, revisionId) {
        super()

        this.document       = document
        this.revisionId     = revisionId

        this.contentNodeId  = 'idPrintContainer'
        this.pageTitle      = 'Notes'
        this.cssFileName    = 'note-view.css'

        this.noteTitle      = document.name
    }

    get htmlContent() {
        return new Promise(async (resolve, reject) => {
            try {
                // create temporary container for document export data
                const printVersionContainer = document.createElement("div")

                // render DocumentExportContainer into temporary container
                ReactDOM.render(
                    <DocumentExportContainer document   = {this.document}
                                             revisionId = {this.revisionId}/>,
                    printVersionContainer,
                    ()=>{
                        debug && console.log(debug, "printVersionContainer", printVersionContainer)

                        setTimeout(()=>{
                            // clone temporary container content for print processing
                            const htmlContent = printVersionContainer.cloneNode(true)

                            debug && console.log(debug, "htmlContent", htmlContent)

                            // unmount component form temporary container and remove temporary container
                            ReactDOM.unmountComponentAtNode(printVersionContainer)
                            $(printVersionContainer).remove()

                            resolve(htmlContent)
                        }, 0)
                    }
                )
            } catch (e) {
                console.error("PrintVersionDocumentView: htmlContent error", e)
                reject()
            }
        })
    }

    async getPageContent() {
        const printContainer = await this.htmlContent

        debug && console.log(debug, "getPageContent", printContainer)

        // remove nodes that we don't want to be printed
        printContainer.querySelectorAll('.pages').forEach(node => {
            node.parentNode.removeChild(node);
        });

        const figures = printContainer.querySelectorAll('.Draftail-block--atomic')
        _.map(figures, element => {

            /*// remove aspect-ratio-component
            const aspect = element.querySelectorAll('.aspect-ratio-component')[0]
            if (aspect) aspect.parentNode.removeChild(aspect)*/

            // remove resize-borders
            const resize = element.querySelectorAll('.resize-borders')[0]
            if (resize) resize.parentNode.removeChild(resize)

            // remove align-selector
            const align = element.querySelectorAll('.align-selector')[0]
            if (align) align.parentNode.removeChild(align)

            // thumbnail css backgroundImage is not printable
            // so we need to replace it with img element
            const attachment = element.querySelectorAll('.attachment-plugin-component')[0]
            const thumbnail = attachment?.querySelectorAll('.thumbnail')[0]
            if (thumbnail) {
                const newEl = document.createElement('img')
                newEl.src = thumbnail.style.backgroundImage.replace('url("', '').replace('")', '')
                newEl.className = "thumbnail"
                newEl.style['object-fit'] = "cover" //"contain"

                thumbnail.parentNode.replaceChild(newEl, thumbnail)
            }

            debug && console.log(debug, "attachment", thumbnail)
        })

        debug && console.log(debug, "getPageContent", figures, printContainer)

        return printContainer
    }


    async _insertContentIntoBody(wnd) {
        const content = await this.getPageContent()
        wnd.document.writeln('<body>' +
            '<div class="print-title">' + this.noteTitle + '</div>' +
            content.outerHTML  +
            '</body>');
    }


}
